import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { navigation } from 'app/navigation/navigation';
import { cloneDeep } from 'lodash';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuGuard implements CanActivateChild {
  constructor(private router: Router) {}

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const userProfile = localStorage.getItem('userProfile');
      const mainURL = state.url.split('/');
      const chkURL = `/${mainURL[1]}/${mainURL[2]}`;
      const isListPage: boolean = state.url.includes('/index');

      if (userProfile) {
        const nav = cloneDeep(navigation);
        let objRef;

        for (let i = 0;  i < nav.length; i++) {
          const obj = nav[i];
          const child: any[] = obj?.children;
          // work around when comming in detail page replace url main from /index to empty string
          const objItem = child?.find(e => chkURL === e?.url ?? chkURL.includes(e?.url?.toString()?.replace('/index', '')));
          if (objItem) {
            objRef = objItem;
            break; // stop for loop after found url
          }
        }

        if (objRef) {
          // if no child in page
          if (!objRef?.pages) return state.url.includes(objRef?.url);

          const profile = JSON.parse(userProfile);
          const menu = JSON.parse(profile?.role?.menu);

          const objRawTest = menu.find(e => e?.id === objRef?.id);

          if (objRawTest?.pages?.length === 0 && objRef?.pages?.length > 0) return objRef?.url?.includes(chkURL);

          const resultTest = objRawTest?.pages?.find(({code}) => isListPage ? code === 'list' : code === 'form');


          if ([null, undefined, '', ' '].includes(resultTest)) {
            if (isListPage && objRawTest?.pages) return true
            this.router.navigateByUrl(`/dashboard/permission-denied/${objRef?.title}`);
          }
          return true;
        }

      }
    return true;
  }

}
